/* Validation methods */
const isEmpty = (value) =>
  value === undefined || value === null || value === '';

export function required(value) {
  if (isEmpty(value)) {
    return 'Fill in this field';
  }
  return null;
}

export function email(value) {
  // Let's not start a debate on email regex. This is just for an example app!
  if (
    !isEmpty(value) &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
  ) {
    return 'Enter a valid email address';
  }
  return null;
}
